import React, { useEffect } from 'react';
import CustomHeader from '../components/CustomHeader';

function CommercialDBPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="subcustom-header-container">
      <CustomHeader />
      <header className="subcustom-header">
        <div className="hero-title-area">
          <div className="hero-subtitle">COMMERCIAL DATABASE</div>
          <h2 className="hero-title">상용 데이터베이스</h2>
        </div>
      </header>
      <div className="breadcrumb">
        <span>Home</span>
        <span>상용 데이터베이스 소프트웨어</span>
      </div>
      <div className="infra-main">
      <h3 className="infra-title">DB 소프트웨어</h3>
      <hr className="infra-divider" />
      <section className="infra-section">
        <div className="infra-info">
          <div className="infra-label">DBMS</div>
          <h4 className="infra-section-title">상용 데이터베이스</h4>
          <div className="infra-list-wrap">
            <ul className="infra-list">
              <li>Oracle</li>
              <li>TmaxTibero</li>
              <li>AgensSql</li>
            </ul>
          </div>
        </div>
        <div className="infra-img">
          <img src="/test_img.png" alt="DB 이미지" />
        </div>
      </section>
      </div>
    </div>
  );
}

export default CommercialDBPage; 